export default __webpack_public_path__ + "static/media/Sign_in.ae280300.svg";